import { createContext, useContext } from 'react';
export const EditorVisibility = createContext(true);
export const useEditorVisible = () => useContext(EditorVisibility);
